import React from 'react';
import { useLocation } from 'react-router-dom';

import { useDashboardDataContext } from './dashboard/dashboard-context';
import Arranger from '../base/arranger';
import { useLeftNavContext } from '../base/left-nav';
import MembersInvitePage from '../members/invite-members';

import { useUserProfile } from '~/client/hooks/user-profile';
import * as GQL from '~/graphql/generated/client';
import { UiWebpageCursor } from '~c/components/base/icon';
import {
  QuickActionButton,
  QuickActionDrawer,
} from '~c/components/base/quick-action';

interface Props {
  className?: string;
  showMember?: boolean;
  type?:
    | GQL.ProjectType.AiSystem
    | GQL.ProjectType.Dataset
    | GQL.ProjectType.ModelCandidate;
}

export const isUserProjectLeadOrOwner = (
  projectData: GQL.Project | undefined,
  userEmail: string
): boolean => {
  const foundMember = projectData?.sharedWith?.find(
    (member) => member?.email === userEmail
  );
  return foundMember?.role === 'Owner';
};

export const canViewProjectSettings = (
  projectData: GQL.Project | undefined,
  userEmail: string,
  opts: {
    hasPlatformManageSystemAdmins: boolean;
    hasOrgManageMembers: boolean;
  }
): boolean => {
  if (opts.hasPlatformManageSystemAdmins) {
    return true;
  }
  if (opts.hasOrgManageMembers) {
    return true;
  }
  return isUserProjectLeadOrOwner(projectData, userEmail);
};

const ProjectQuickAction: React.FC<Props> = ({ className, showMember }) => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  const handleOpen = () => setOpen(true);
  const { state } = useLeftNavContext();
  const { currentRoute } = state;
  const isAiSystemSection = currentRoute?.startsWith('/ai-system/');
  const isFunctionalModelSection = location.pathname.includes('/ai-usecase/');
  const isFunctionalModelsListView =
    location.pathname.endsWith('/ai-usecases-list');

  const { userProfile } = useUserProfile();

  const { project, refetchProjectFromId: refetch } = useDashboardDataContext();

  const handleClose = () => {
    if (refetch) {
      refetch();
    }
    setOpen(false);
  };

  const isProjectLeadOrOwner = isUserProjectLeadOrOwner(
    project as GQL.Project,
    userProfile?.email ?? ''
  );

  return (
    <div className={className}>
      <QuickActionDrawer header={{ text: 'QUICK ACTIONS' }}>
        <Arranger direction="column" sx={{ gap: '5px' }}>
          {isAiSystemSection && !isFunctionalModelSection && (
            <>
              {!isFunctionalModelsListView && showMember && (
                <>
                  {isProjectLeadOrOwner && (
                    <>
                      <QuickActionButton
                        icon={UiWebpageCursor}
                        onClick={handleOpen}
                      >
                        Add Member
                      </QuickActionButton>
                      <MembersInvitePage onClose={handleClose} open={open} />
                    </>
                  )}
                </>
              )}
            </>
          )}
        </Arranger>
      </QuickActionDrawer>
    </div>
  );
};

export default ProjectQuickAction;
